import { I18n } from "@assets/strings";
import React from "react";
import { formatDayMonthAndYear } from "@utils/date";
import { useIsMobile } from "@utils/hooks";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Stack } from "@ui/components/layout";
import { ApplicationFileInformation } from "@ui/components/application/applicationFileInformation";
import { ApplicationInformationContainer } from "@ui/components/application/applicationInformationContainer";
import { SummaryViewProps } from "@ui/components/application/summaryView";

export const PersonalInformationSummaryView: React.FC<SummaryViewProps> = ({ application, ...htmlProps }) => {
	const isMobile = useIsMobile();

	return (
		<Stack gap={20} style={{ width: "100%", display: "grid" }} {...htmlProps}>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.firstname.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.firstName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.familyname.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.familyName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.country_residence.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.countryResidence}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.nationality.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.nationality}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.email.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{application.email}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			{application.phoneNumber && (
				<ApplicationInformationContainer isDocument={isMobile}>
					<PrimaryMedium>{I18n.t(`application.form.phone_number.label`)}</PrimaryMedium>
					<ApplicationFileInformation>{application.phoneNumber}</ApplicationFileInformation>
				</ApplicationInformationContainer>
			)}
			<ApplicationInformationContainer isDocument={isMobile}>
				<PrimaryMedium>{I18n.t(`application.form.date_birth.label`)}</PrimaryMedium>
				<ApplicationFileInformation>{formatDayMonthAndYear(application.dateBirth)}</ApplicationFileInformation>
			</ApplicationInformationContainer>
		</Stack>
	);
};
